import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { Search } from 'carbon-components-react';
import { MapGetPlaceSuggestPayload } from 'types';
import { getPlaceSuggestStart } from 'redux/map/actions';
import Util from 'utilities/helper.util';

const LotNumberSearch: React.FC<Props> = ({
  showHideBox,
  placeholder,
  noOpenButton,
  currentScope,
  searchResult
}) => {
  const dispatch = useDispatch();

  const [searchPlanInputValue, setSearchPlanInputValue] = useState<string>('');
  const [searchLotInputValue, setSearchLotInputValue] = useState<string>('');

  const [planPlaceholder, setPlanPlaceholder] = useState<string>('');
  const [lotPlaceholder, setLotPlaceholder] = useState<string>('');

  // Ref: https://www.freecodecamp.org/news/debounce-and-throttle-in-react-with-hooks/
  const debouncedFunction = useCallback(
    Util.debounce(async (args: string[]) => {
      const value = args[0];
      const type = args[1];
      const partnerValue = args[2];

      const query = (type === 'PLAN'
        ? `${value} ${partnerValue}`
        : `${partnerValue} ${value}`
      ).trim();

      const payload: MapGetPlaceSuggestPayload = {
        datasets: currentScope,
        query,
        fields: 'region,locality',
        limit: '5',
        location: `${window.loadedView.center.longitude},${window.loadedView.center.latitude}`
      };
      dispatch(getPlaceSuggestStart(payload));
    }, 350),
    [currentScope]
  );

  const handleInputChange = (type: string, value: string) => {
    type === 'PLAN'
      ? setSearchPlanInputValue(value)
      : setSearchLotInputValue(value);

    debouncedFunction(
      value,
      type,
      type === 'PLAN' ? searchLotInputValue : searchPlanInputValue
    );
  };

  useEffect(() => {
    if (placeholder) {
      const placeholderStrArr = placeholder.split('/');
      setPlanPlaceholder(placeholderStrArr[0]);
      setLotPlaceholder(placeholderStrArr[1]);
    }
  }, [placeholder]);

  useEffect(() => {
    if (!searchResult) {
      setSearchPlanInputValue('');
      setSearchLotInputValue('');
    }
  }, [searchResult]);

  return (
    <div className="mls-multiple-layout-search">
      <div className={`mls-control-container`}>
        <Search
          id="mls-input-01"
          labelText=""
          size="sm"
          value={searchPlanInputValue}
          placeHolderText={planPlaceholder}
          onFocus={showHideBox}
          onChange={(evt) => handleInputChange('PLAN', evt.target.value)}
          className={`${!noOpenButton ? 'bx--search-open-button' : ''}`}
        />
      </div>
      <div className={`mls-control-container`}>
        <Search
          id="mls-input-02"
          labelText=""
          size="sm"
          value={searchLotInputValue}
          placeHolderText={lotPlaceholder}
          onFocus={showHideBox}
          onChange={(evt) => handleInputChange('LOT', evt.target.value)}
          className={`${!noOpenButton ? 'bx--search-open-button' : ''}`}
        />
      </div>
    </div>
  );
};

const propTypes = {
  showHideBox: PropTypes.func.isRequired,
  currentScope: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  noOpenButton: PropTypes.bool,
  searchResult: PropTypes.string
};

type Props = PropTypes.InferProps<typeof propTypes>;

LotNumberSearch.defaultProps = {
  noOpenButton: false,
  searchResult: ''
};

export default LotNumberSearch;
